import script from "./VAuthInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./VAuthInput.vue?vue&type=script&lang=ts&setup=true"

import "./VAuthInput.vue?vue&type=style&index=0&id=6a81e21e&lang=sass"

const __exports__ = script;

export default __exports__